import React, { useState } from "react";
import { pnpLogo } from "../../../Asserts";
import useDeviceType from "../../../Utiles/FindDevice";
import { useLocation, useNavigate } from "react-router";
import { useFormik } from "formik";
import { resetPasswordValidationSchema } from "../../../Validation/formValidation";
import axios from "axios";
import { baseURL } from "../../../services/axiosConfig";
import { toast } from "react-toastify";
import { FooterTab, MobileFooter } from "../../../../Components/GreenHome/Footer";

const ResetPassword = () => {
  const deviceType = useDeviceType();
  const navigate = useNavigate();
  const location = useLocation();
  const userEmail = location.pathname.split("/").pop();
  const [isLoading, setIsLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmNewPassword: "",
    },
    validationSchema: resetPasswordValidationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setIsLoading(true);
      try {
        const token = localStorage.getItem("token");
        const res = await axios.put(
          `${baseURL}/accounts/changepassword`,
          {
            email: userEmail,
            newpassword: values.newPassword,
            confirmpassword: values.confirmNewPassword,
            token,
          }
        );
        if (res?.data?.status === "Success") {
          toast.success("Password reset successfully");
          navigate("/login");
        } else {
          toast.error(res?.data?.message || "Failed to reset password");
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            error?.response?.data?.data?.message ||
            "An error occurred while resetting password"
        );
      } finally {
        setIsLoading(false);
        setSubmitting(false);
      }
    },
  });

  return (
    <div
      style={{
        backgroundImage: `url('/v2/images/bg/${
          deviceType === "mobile" ? "auth-bg-mobile.png" : "auth-bg.png"
        }')`,
      }}
      className="bg-cover bg-no-repeat bg-center min-h-screen overflow-hidden flex flex-col justify-between"
    >
      <div
        className={`flex ${
          deviceType === "mobile"
            ? "flex-col py-16"
            : "lg:flex-row justify-between px-24 py-[56px] lg:py-[34px] 2xl:py-[56px]"
        } bg-cover bg-no-repeat bg-center items-start`}
      >
        {deviceType !== "mobile" && (
          <div className={`text-white`}>
            <a href="/"><img src={pnpLogo} alt="Logo" className="h-28 lg:h-44 mb-4 md:-my-6 lg:my-4" /></a>
          </div>
        )}

        <div
          className={`flex flex-col ${
            deviceType === "mobile" ? "w-full px-6" : "h-full lg:mt-12 lg:mx-24"
          } items-center justify-center`}
        >
          {deviceType === "mobile" && (
            <a href="/">
              <img src={pnpLogo} alt="Logo" className="h-32 w-auto mb-6" />
            </a>
          )}
          <div
            className={`bg-white rounded-b-[12px] rounded-t-[8px] ${
              deviceType === "mobile"
                ? "w-[100%] mx-auto my-4"
                : deviceType === "tablet"
                ? "w-[350px] max-w-[550px] h-96"
                : deviceType === "laptop"
                ? "w-[450px] max-w-[500px] h-96"
                : "w-[400px] max-w-[420px] h-full"
            }`}
          >
            <div
              className={`bg-gradient-to-r h-[6px] p-1 rounded-tl-[12px] rounded-tr-[12px] from-[#00C05B] to-[#007FFF] w-full`}
            ></div>
            <div className="h-full flex items-center justify-center">
              <div
                className={`${
                  deviceType === "mobile"
                    ? "px-6 py-6"
                    : deviceType === "tablet"
                    ? "px-6 py-12"
                    : "px-10 py-6"
                } flex flex-col align-middle w-full`}
              >
                <div className={deviceType === "mobile" ? "mb-4 mx-auto" : "mb-6"}>
                  <h2
                    className={`font-bold font-archivo text-[#0081F8] ${
                      deviceType === "mobile" ? "text-lg mb-2" : "text-xl lg:text-[22px] mb-3"
                    }`}
                  >
                    Reset Password
                  </h2>
                  <p className={`text-black/50 ${
                    deviceType === "mobile"
                      ? "text-sm leading-relaxed mb-1"
                      : "lg:text-[16px] mb-2"
                  }`}>
                     Enter a strong password with atleast <br />
                  eight characters
                  </p>
                </div>
                <form onSubmit={formik.handleSubmit} className="w-full">
                  <div className="mt-6 grid grid-cols-1 gap-4">
                    <div>
                      <div className="relative">
                        <input
                          type={showNewPassword ? "text" : "password"}
                          name="newPassword"
                          placeholder="New Password"
                          className={`px-4 py-3 pr-12 border placeholder-black/50 border-[#00000033] rounded-full focus:outline-none w-full ${
                            formik.touched.newPassword && formik.errors.newPassword
                              ? "border-red-500"
                              : ""
                          }`}
                          value={formik.values.newPassword}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          autoComplete="new-password"
                        />
                        <button
                          type="button"
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        >
                          {showNewPassword ? (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                            </svg>
                          ) : (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" fill="currentColor"/>
                            </svg>
                          )}
                        </button>
                      </div>
                      {formik.touched.newPassword && formik.errors.newPassword && (
                        <div className="text-red-500 text-xs mt-1 pl-2">
                          {formik.errors.newPassword}
                        </div>
                      )}
                    </div>
                    <div>
                      <div className="relative">
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          name="confirmNewPassword"
                          placeholder="Confirm New Password"
                          className={`px-4 py-3 pr-12 border placeholder-black/50 border-[#00000033] rounded-full focus:outline-none w-full ${
                            formik.touched.confirmNewPassword && formik.errors.confirmNewPassword
                              ? "border-red-500"
                              : ""
                          }`}
                          value={formik.values.confirmNewPassword}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          autoComplete="new-password"
                        />
                        <button
                          type="button"
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        >
                          {showConfirmPassword ? (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                            </svg>
                          ) : (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" fill="currentColor"/>
                            </svg>
                          )}
                        </button>
                      </div>
                      {formik.touched.confirmNewPassword && formik.errors.confirmNewPassword && (
                        <div className="text-red-500 text-xs mt-1 pl-2">
                          {formik.errors.confirmNewPassword}
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                className={`flex items-center ${
                  deviceType === "mobile"
                    ? "text-[14px] mt-8"
                    : deviceType === "desktop"
                    ? "text-[16px] mt-8"
                    : "mt-8"
                } justify-between`}
              >
                <button
                  type="submit"
                  className={`${formik.isSubmitting || !formik.isValid ? "bg-gray-400" : "bg-[#3B82F6] hover:bg-[#2563EB]" } mx-auto w-full text-[16px] font-medium py-3 rounded-full text-white transition duration-200`}
                  disabled={formik.isSubmitting}
                >
                  {formik.isSubmitting ? "Saving..." : "Save Password"}
                </button>
              </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {deviceType === "mobile" ?
           <MobileFooter /> :
            <FooterTab component="privacyPolicy" className="mt-auto" />
           }
    </div>
  );
};

export default ResetPassword;